import { BaseService } from "../baseService";
import { FileAPIService } from "../fileAPIService";
import { ActiveAntsWarehouseCheckInAPIService } from "./activeAntsWarehouseCheckInAPIService";
import { sanitiseParams } from "src/utils";
import { ISOString, GetWarehouseCheckInsQueryParams } from "src/types";

class ActiveAntsWarehouseCheckInService extends BaseService<ActiveAntsWarehouseCheckInAPIService> {
  private readonly fileAPIService: FileAPIService;

  constructor(apiService: ActiveAntsWarehouseCheckInAPIService, fileAPIService: FileAPIService) {
    super(apiService);
    this.fileAPIService = fileAPIService;
  }

  @sanitiseParams()
  async getActiveAntsWarehouseCheckIns(queryParams: GetWarehouseCheckInsQueryParams) {
    return await this.apiService.getActiveAntsWarehouseCheckIns(queryParams);
  }

  @sanitiseParams()
  async getActiveAntsWarehouseCheckInById(warehouseCheckInId: string, timestamp: ISOString) {
    return await this.apiService.getActiveAntsWarehouseCheckInById(warehouseCheckInId, timestamp);
  }

  @sanitiseParams()
  async updateOpsNote(warehouseCheckInId: string, timestamp: ISOString, opsNote: string | null) {
    return await this.apiService.patchActiveAntsWarehouseCheckInOpsNote(warehouseCheckInId, timestamp, { opsNote });
  }

  @sanitiseParams()
  async getGoodsInExportUrl(exportFileId: string) {
    const { signedUrl, fileName } = await this.apiService.postActiveAntsGoodsInExportUrl(exportFileId);

    const fileBlob = await this.fileAPIService.getFile(signedUrl);

    return new File([fileBlob], fileName, { type: fileBlob.type, lastModified: new Date().getTime() });
  }
}

export { ActiveAntsWarehouseCheckInService };
